import { render, staticRenderFns } from "./Crowdtype.vue?vue&type=template&id=3f47b079&scoped=true"
import script from "./Crowdtype.vue?vue&type=script&lang=js"
export * from "./Crowdtype.vue?vue&type=script&lang=js"
import style0 from "./Crowdtype.vue?vue&type=style&index=0&id=3f47b079&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f47b079",
  null
  
)

export default component.exports